var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-feed-state flex items-center flex-col pt-12 pb-20 mx-auto rounded text-medium bg-grey-100"},[_c('div',{staticClass:"icon rounded-full mb-4 w-24 h-24"}),_c('span',{staticClass:"text-grey-dark text-lg font-normal"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }